import { WrapContent } from "types/generic/types";

export const getWrapContentClassNames = ({
  xsWrapContent,
  mdWrapContent,
  lgWrapContent,
  xlWrapContent,
}: WrapContent) => {
  return {
    [`wrapContent-xs-${xsWrapContent || ""}`]: !!xsWrapContent,
    [`wrapContent-md-${mdWrapContent || ""}`]: !!mdWrapContent,
    [`wrapContent-lg-${lgWrapContent || ""}`]: !!lgWrapContent,
    [`wrapContent-xl-${xlWrapContent || ""}`]: !!xlWrapContent,
  };
};
